import { cva, VariantProps } from "class-variance-authority";
import { useStore } from "../../../store";

const buttonStyles = cva(
	"rounded-4xl border-2 text-center disabled:bg-btn-disabled disabled:border-btn-disabled disabled:text-btn-disabled-text disabled:cursor-not-allowed min-w-fit text-xl",
	{
		variants: {
			intent: {
				primary: "bg-black text-white border-black",
				secondary: "bg-white border-black text-black",
			},
			size: {
				"x-small": "px-1 py-2",
				small: "px-2 py-4",
				medium: "px-14 py-5",
				large: "px-16 py-5",
			},
		},
		defaultVariants: {
			intent: "primary",
			size: "medium",
		},
	},
);

type Props = VariantProps<typeof buttonStyles> & {
	label: string;
	disabled?: boolean;
	loading?: boolean;
	form?: string;
	onClick: (_event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function Button({ intent, size, label, disabled = false, loading = false, form, onClick }: Props) {
	const color = useStore((state) => state.config?.theming?.brandColor);

	return (
		<>
			<button
				style={{
					backgroundColor: disabled ? undefined : intent !== "secondary" ? color : "",
					border: disabled ? undefined : `2px solid ${color}`,
					color: disabled ? undefined : intent === "secondary" ? color : "",
				}}
				onClick={onClick}
				disabled={disabled}
				className={`${buttonStyles({ intent, size })}`}
				type="submit"
				form={form}
			>
				<div className="flex text-base mr-7">
					<div className={`h-6 w-6 ${loading ? "loader" : ""} mr-1`}></div>
					<span>{label}</span>
				</div>
			</button>
		</>
	);
}
